import DOMPurify from 'dompurify';

export type SanitizeHtmlComponentProps = {
    // html
    children: string;
};

interface AllowedAttributes {
    [tagName: string]: string[];
}

export function sanitizeHtml(rawHtml: string): string {
    const rawHtmlElement = document.createElement('div');
    rawHtmlElement.innerHTML = rawHtml;

    const allowedTags = [];
    allowedTags.push('strong', 'b', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'a', 'ul', 'ol', 'li', 'p', 'br', 'em', 'button');

    const allowedAttributes: AllowedAttributes = {
        table: ['border', 'cellpadding', 'cellspacing'],
        td: ['colspan', 'rowspan'],
        th: ['colspan', 'rowspan', 'scope'],
        img: ['src', 'alt', 'width', 'height'],
        a: ['href', 'target', 'rel'],
        button: ['onclick', 'class'],
        ul: ['style'],
        ol: [],
        li: [],
        div: ['style'],
        span: ['style'],
    };

    const allowedAttr: string[] = Object.values(allowedAttributes).reduce((acc, attrs) => acc.concat(attrs), []);

    // First, let's process the HTML to replace eldo.lu hashtag links with buttons
    let processedHtml = rawHtml;
    
    // Regular expression to match eldo.lu links with hashtags
    const eldoHashtagLinkRegex = /<a\s+[^>]*href\s*=\s*["']([^"']*(?:www\.eldo\.lu|https?:\/\/(?:www\.)?eldo\.lu)[^"']*#[^"']+)["'][^>]*>(.*?)<\/a>/gi;
    
    processedHtml = processedHtml.replace(eldoHashtagLinkRegex, (match: string, href: string, linkText: string) => {
        // Extract the hashtag from the URL
        const hashIndex = href.indexOf('#');
        if (hashIndex !== -1) {
            const hashtag = href.substring(hashIndex + 1);
            // Decode URL-encoded characters (like %C3%AB to ë)
            const decodedHashtag = decodeURIComponent(hashtag);
            
            return `<button onclick="window.location.hash = '${decodedHashtag}'">${linkText}</button>`;
        }
        return match; // Return original if no hashtag found
    });

    const sanitizedHtml = DOMPurify.sanitize(processedHtml, {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: allowedAttr,
        FORBID_ATTR: ['style', 'onerror', 'onload', 'width'],
        ADD_ATTR: ['onclick'], // Allow onclick for our buttons
    });

    return sanitizedHtml;
}

export default function SanitizeHtmlComponent({ children }: SanitizeHtmlComponentProps) {
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(children) }} />;
}
